// === src/pages/dashboard/Vehicles.jsx ===
import React, { useEffect, useState } from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Legend
} from "recharts";
import * as XLSX from "xlsx";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";

const statusColors = ["#f97316", "#10b981", "#facc15", "#9ca3af"];

const Vehicles = () => {
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [vehicleStats, setVehicleStats] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("All");

  useEffect(() => {
    const fetchData = () => {
      setTimeout(() => {
        setVehicleStats([
          { label: "Total", value: 124 },
          { label: "Active", value: 98 },
          { label: "In Repair", value: 12 },
          { label: "Idle", value: 14 },
        ]);

        setChartData([
          { name: "Mon", trips: 24 },
          { name: "Tue", trips: 30 },
          { name: "Wed", trips: 18 },
          { name: "Thu", trips: 36 },
          { name: "Fri", trips: 40 },
        ]);

        setLoading(false);
      }, 300);
    };

    fetchData();
  }, []);

  const exportStats = () => {
    setProcessing(true);
    setTimeout(() => {
      const worksheet = XLSX.utils.json_to_sheet(vehicleStats);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "FleetStats");
      XLSX.writeFile(workbook, "fleet-stats.xlsx");
      toast.success("Stats exported to Excel");
      setProcessing(false);
    }, 400);
  };

  return (
    <div className="relative min-h-[600px]">
      {(loading || processing) && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/80 dark:bg-black/60 rounded">
          <Loader />
        </div>
      )}
      <div className={`${loading || processing ? "opacity-30 pointer-events-none" : ""}`}>
        <h2 className="text-xl font-semibold mb-4">Fleet Metrics</h2>

        <div className="flex flex-wrap items-end gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium">Vehicle</label>
            <select
              className="border px-2 py-1 rounded bg-white dark:bg-gray-800 text-black dark:text-white"
              value={selectedVehicle}
              onChange={(e) => setSelectedVehicle(e.target.value)}
            >
              <option>All</option>
              <option>Truck A</option>
              <option>Truck B</option>
            </select>
          </div>
          <button
            onClick={exportStats}
            className="bg-green-600 text-white px-4 py-2 rounded shadow"
          >
            Export Stats
          </button>
        </div>

        {/* Stat Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {vehicleStats.map((stat, i) => (
            <div
              key={i}
              className="bg-orange-100 dark:bg-orange-800 text-center p-4 rounded shadow"
            >
              <p className="text-sm">{stat.label}</p>
              <p className="text-2xl font-bold">{stat.value}</p>
            </div>
          ))}
        </div>

        {/* Weekly Trips */}
        <div className="bg-gray-100 dark:bg-[#1e293b] p-6 rounded shadow mb-6">
          <h3 className="text-lg font-semibold mb-4">Trips This Week</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" stroke="#8884d8" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="trips" fill="#f97316" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Status Pie Chart */}
        <div className="bg-gray-100 dark:bg-[#1e293b] p-6 rounded shadow">
          <h3 className="text-lg font-semibold mb-4">Vehicle Status Overview</h3>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie
                data={vehicleStats.slice(1)}
                dataKey="value"
                nameKey="label"
                outerRadius={100}
                label
              >
                {vehicleStats.slice(1).map((entry, index) => (
                  <Cell key={index} fill={statusColors[index % statusColors.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Vehicles;